module.exports = __webpack_public_path__ + "acf3dcb7ff752b5296ca23ba2c7c2606.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 1494
// module chunks = 0